import {Typography} from '@mui/material'
import {Button} from '@mui/material'
import styled from 'styled-components'

export const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
`

export const Title = styled(Typography)`
  font-weight: 500;
  font-size: 20px;
  line-height: 23px;
  color: #222222;
`

export const ActionWrapper = styled.div``

export const ButtonWrapper = styled(Button)`
  text-transform: initial;
`
